import "dayjs/locale/uk";

import dayjs, { Dayjs } from "dayjs";
import { useContext, useEffect, useState } from "react";

import Checkbox from "antd/lib/checkbox";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import DatePicker from "antd/lib/date-picker";
import type { DatePickerProps } from "antd/es/date-picker";
import { DatePickersProps } from "./types";
import { DatepickerContext } from "../../../contexts/datepicker/index.context";
import Input from "antd/lib/input";
import { MergedColumnType } from "../table/utils/types";
import { ModalContext } from "../../../contexts/modal/index.context";
import Select from "antd/lib/select";
import { SessionContext } from "../../../contexts/session/index.context";
import Space from "antd/lib/space";
import Tooltip from "antd/lib/tooltip";
import { TranslationContext } from "../../../contexts/translation/index.context";
import { request } from "../../../services";
import styles from "./styles.module.scss";
import { useLocation } from "react-router-dom";
import React from "react";

import en from "antd/es/date-picker/locale/en_US";
import ua from "antd/es/date-picker/locale/uk_UA";
//UI

//Locale

dayjs.locale("uk");

const { Search } = Input;

export default function DatePickersComponent(props: DatePickersProps) {
  const location = useLocation();
  const url = props.url || location.pathname;
  const isListOfDocuments = url === "/documents/list-of-documents";
  const isElectronicMailOfDocuments = url === "/documents/electronic-mail";
  const isDocuments = url.split("/").slice(0, 2).join("/") === "/documents";
  const isIncomingEmailOfDocuments = url === "/directories/incoming-email";
  const usingEmailData =
    isIncomingEmailOfDocuments &&
    JSON.parse(sessionStorage.getItem("electronic_mail_data") || "null")
      ?.selectedEmail;
  const context = useContext(ModalContext);
  const datePickerContext = useContext(DatepickerContext);
  const { intl, language } = useContext(TranslationContext);

  const { setSessionData, currentPageChange } = useContext(SessionContext);
  const dateFormatList = ["DD.MM.YYYY", "DD-MM-YYYY"];
  const startOf = isListOfDocuments ? "month" : "year";
  /**
   * Якщо це вхідний електронний лист, то відображаємо 14 днів назад,
   * інакше відображаємо початок місяця або року в залежності від типу документа
   */
  const fromDate = isIncomingEmailOfDocuments
    ? dayjs().subtract(14, "day").startOf("day")
    : dayjs().startOf(startOf);
  /** Якщо це вхідний електронний лист, то відображаємо до сьогодні */
  const toDate = isIncomingEmailOfDocuments
    ? dayjs().endOf("day")
    : dayjs().endOf(startOf);

  const [typeDocId, setTypeDocId] = useState<number | undefined>(undefined);
  const [selectData, setSelectData] = useState<MergedColumnType[]>([]);
  const [from, setFrom] = useState<Dayjs>(fromDate);
  const [to, setTo] = useState<Dayjs>(toDate);
  const [inWork, setInWork] = useState(false);
  const [isAttachment, setIsAttachment] = useState<boolean | undefined>(
    undefined
  );
  const [str, setStr] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  const selectOptions = selectData.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  useEffect(() => {
    datePickerContext.setLoading(loading);
  }, [loading]);
  // useEffect(() => {
  //   fetchData(from, to);
  // }, []);

  useEffect(() => {
    isListOfDocuments && fetchSelectData();
  }, []);

  useEffect(() => {
    if (onChangeFrom || context.refresh) {
      // console.log(
      //   "Виконується useEffect з DatePickersComponent context.refresh ",
      //   context.refresh
      // );
      // Якщо це документи або оновлення з контексту, або таблиця порожня, то оновлюємо дані
      if(isDocuments || context.refresh) 
        // datePickerContext?.isEmptyTable(url) && 
          fetchData(from, to, undefined, typeDocId, str, isAttachment);
      context.setRefresh(false);
    }
  }, [context.refresh]);

  // Компонент для оновлення даних(скріпки) в таблиці Вхідні... після додавання/видалення файлів
  useEffect(() => {
    // console.log(
    //   "Виконується useEffect з DatePickersComponent context.refresh 2222 ",
    //   context.refresh
    // );
    if (isDocuments)
      fetchData(from, to, undefined, typeDocId, str, isAttachment);
    context.setRefresh(false);
    datePickerContext.setRefreshDatepickerContext(false);
  }, [datePickerContext.refreshDatepickerContext]);

  // const updateObject = (arr: any, obj: any) => {
  //   const foundObj = arr.find(item => item.id === obj.id);
  //   if (foundObj) {
  //     Object.assign(obj, foundObj);
  //   }
  // };

  const fetchSelectData = async () => {
    if (selectData?.length > 0) return;
    const content = (
      await request(`${url}/getdoctype`, {
        method: "get",
        cancelTokenKey: "getdoctype",
      })
    )?.content;
    setSelectData(content || []);

    const defaultOption = content?.find((item: any) => item.id === 1);
    if (defaultOption && !typeDocId) {
      setTypeDocId(defaultOption.id);
      fetchData(from, to, undefined, defaultOption.id, str);
    }
  };

  const onSelectChange = (value: number | undefined) => {
    setTypeDocId(value);
    fetchData(from, to, undefined, value, str);
  };

  const fetchData = async (
    from: Dayjs,
    to: Dayjs,
    inWork?: boolean,
    typeDocId?: number,
    str?: string,
    isAttachment?: boolean
  ) => {
    if (from.isAfter(to)) {
      return;
    }
    setLoading(true);
    // не работает при первой загрузке, т.к. datePickerContext.loading = false
    datePickerContext.setLoading(true);
    // console.log("Виконується реквест з DatePickersComponent ");
    const content = (
      await request(`${url}/getdatatable`, {
        method: "post",
        body: {
          typeDocId,
          from,
          to,
          inWork,
          isAttachment,
          str,
          url,
          ...(isIncomingEmailOfDocuments ? { email: usingEmailData } : {}),
        },
        cancelTokenKey: "getdatatable",
      })
    )?.content;
    const dataWithKeys =
    content?.map((item: any) => ({ ...item, key: item.id })) || [];
    datePickerContext?.onTableDataValueChange({
      url: url,
      tableData: dataWithKeys || [],
    });
    currentPageChange(dataWithKeys);
    // datePickerContext.setTableData(content);
    datePickerContext.setLoading(false);
  };

  const onChangeFrom: DatePickerProps["onChange"] = (date, dateString) => {
    if (date) {
      setFrom(date);
      fetchData(date, to, undefined, undefined, str, isAttachment);
    }
  };

  const onChangeTo: DatePickerProps["onChange"] = (date, dateString) => {
    if (date) {
      setTo(date);
      fetchData(from, date, undefined, undefined, str, isAttachment);
    }
  };

  const onChangeInWork = async (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      setInWork(e.target.checked);
      fetchData(from, to, e.target.checked);
    }
  };
  const onChangeIsAttachment = async (e: CheckboxChangeEvent) => {
    setIsAttachment(e.target.checked);
    fetchData(from, to, undefined, undefined, str, e.target.checked);
  };

  const onSearch = (value: string) => {
    setStr(value);
    fetchData(from, to, undefined, typeDocId, value, isAttachment);
  };

  const extraButtons: Partial<Record<string, JSX.Element>> = {
    isListOfDocuments: (
      <Tooltip title={intl("the-search-is-performed")}>
        <Search
          placeholder={intl("search")}
          onSearch={onSearch}
          style={{ width: 200 }}
        />
      </Tooltip>
    ),
    electronicMailOfDocuments: (
      <>
        <Tooltip
          title={
            isElectronicMailOfDocuments
              ? intl("the-search-is-performed-address")
              : intl("the-search-is-performed-incoming-email")
          }
        >
          <Search
            placeholder={intl("search")}
            onSearch={onSearch}
            style={{ width: 200 }}
          />
        </Tooltip>
        {isIncomingEmailOfDocuments && (
          <Checkbox onChange={onChangeIsAttachment}>
            {intl("with-attachment")}
          </Checkbox>
        )}
      </>
    ),
    showCheckbox: (
      <Checkbox onChange={onChangeInWork}>{intl("in-work")}</Checkbox>
    ),
    // Додавай інші кнопки при потребі
  };
  const flags = {
    isListOfDocuments,
    electronicMailOfDocuments:
      !isListOfDocuments &&
      (isElectronicMailOfDocuments || isIncomingEmailOfDocuments),
    showCheckbox:
      !isListOfDocuments &&
      !isElectronicMailOfDocuments &&
      !isIncomingEmailOfDocuments,
    // Додай інші прапори тут
  };

  return (
    <Space
    style={{width: "700px"}}
      size={"middle"}
      className={
        isIncomingEmailOfDocuments
          ? styles["datepicker-space-buttons"]
          : styles["datepicker-space"]
      }
    >
      {isListOfDocuments && (
        <Select
          showSearch
          allowClear
          style={{ width: 200 }}
          value={typeDocId}
          placeholder={intl("document-type")}
          optionFilterProp="label"
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          onChange={onSelectChange}
          onDropdownVisibleChange={fetchSelectData}
          options={selectOptions}
        />
      )}
      <DatePicker
        defaultValue={fromDate}
        format={dateFormatList}
        onChange={onChangeFrom}
        className={styles["ant-picker-input-input"]}
        placeholder={intl("choose-date-placeholder")}
        locale={language ? ua : en}
      />
      <DatePicker
        defaultValue={toDate}
        format={dateFormatList}
        onChange={onChangeTo}
        placeholder={intl("choose-date-placeholder")}
        locale={language ? ua : en}    
      />
      {/* {Object.entries(flags).map(([key, value]) => value && extraButtons[key])} */}

      {Object.entries(flags).map(([k, v]) =>
        v ? <React.Fragment key={k}>{extraButtons[k]}</React.Fragment> : null
      )}

      {/* {isListOfDocuments ? (
        <Tooltip title={intl("the-search-is-performed")}>
          <Search
            placeholder={intl("search")}
            onSearch={onSearch}
            style={{ width: 200 }}
          />
        </Tooltip>
      ) : isElectronicMailOfDocuments || isIncomingElectronicMailOfDocuments ? (
        <Tooltip
          title={
            isElectronicMailOfDocuments
              ? intl("the-search-is-performed-address")
              : intl("the-search-is-performed-incoming-email")
          }
        >
          <Search
            placeholder={intl("search")}
            onSearch={onSearch}
            style={{ width: 200 }}
          />
        </Tooltip>
      ) : (
        <Checkbox onChange={onChangeInWork}>{intl("in-work")}</Checkbox>
      )} */}
    </Space>
  );
}
